document.addEventListener('DOMContentLoaded', () => {

  /* ========================================================
     EXCLUSIONS
     On ne touche pas aux sliders produit, galerie, slideshow,
     barre d'annonce, etc.
     ======================================================== */

  const isExcludedSlider = (component) => {
    return (
      component.closest('.product__media-wrapper') ||
      component.closest('.thumbnail-slider') ||
      component.closest('.product-media-modal') ||
      component.closest('.slideshow') ||
      component.closest('.announcement-bar')
    );
  };


  /* ========================================================
     INITIALISATION D'UN SLIDER
     ======================================================== */

  const initSliderDots = (component) => {

    if (component.dataset.tcDotsInitialized === 'true') return;
    if (isExcludedSlider(component)) return;

    const slider = component.querySelector('.slider');

    if (!slider) return;

    const slides = Array.from(
      slider.querySelectorAll(':scope > .slider__slide')
    );

    const sliderButtons = component.querySelector('.slider-buttons');

    if (!sliderButtons || slides.length <= 1) return;


    component.dataset.tcDotsInitialized = 'true';
    component.classList.add('tc-slider-dots-enabled');


    /* ======================================================
       CRÉATION DU CONTENEUR DES PASTILLES
       ====================================================== */

    const dotsWrapper = document.createElement('div');

    dotsWrapper.className = 'tc-slider-dots';
    dotsWrapper.setAttribute('role', 'group');
    dotsWrapper.setAttribute(
      'aria-label',
      'Navigation du carrousel'
    );

    sliderButtons.appendChild(dotsWrapper);


    let dots = [];
    let positions = [];


    /* ======================================================
       CALCUL DES POSITIONS
       ====================================================== */

    const calculatePositions = () => {

      const mobile = window.matchMedia(
        '(max-width: 749px)'
      ).matches;


      /* ----------------------------------------------------
         MOBILE
         1 carte = 1 position
         ---------------------------------------------------- */

      if (mobile) {

        positions = slides.map((slide) => slide.offsetLeft);

        return;

      }


      /* ----------------------------------------------------
         DESKTOP / TABLETTE
         Nombre de positions =
         nombre de produits - colonnes visibles + 1
         ---------------------------------------------------- */

      const columnsClass = Array.from(slider.classList).find(
        (className) =>
          className.startsWith('grid--') &&
          className.endsWith('-col-desktop')
      );


      let visibleColumns = 1;


      if (columnsClass) {

        const match = columnsClass.match(
          /grid--(\d+)-col-desktop/
        );

        if (match) {
          visibleColumns = parseInt(match[1], 10);
        }

      }


      const totalSlides = slides.length;

      const numberOfPositions = Math.max(
        1,
        totalSlides - visibleColumns + 1
      );


      positions = [];


      for (let i = 0; i < numberOfPositions; i++) {

        const slide = slides[i];

        if (!slide) continue;

        positions.push(slide.offsetLeft);

      }

    };


    /* ======================================================
       CRÉATION / RECRÉATION DES PASTILLES
       ====================================================== */

    const buildDots = () => {

      calculatePositions();

      dotsWrapper.innerHTML = '';

      dots = [];


      positions.forEach((position, index) => {

        const dot = document.createElement('button');

        dot.type = 'button';
        dot.className = 'tc-slider-dot';

        dot.setAttribute(
          'aria-label',
          `Afficher la position ${index + 1} sur ${positions.length}`
        );


        dot.addEventListener('click', () => {

          slider.scrollTo({
            left: position,
            behavior: 'smooth'
          });

        });


        dotsWrapper.appendChild(dot);

        dots.push(dot);

      });

    };


    /* ======================================================
       MISE À JOUR DE LA PASTILLE ACTIVE
       ====================================================== */

    const updateDots = () => {

      if (!positions.length) return;


      const currentScroll = slider.scrollLeft;

      let nearestIndex = 0;
      let smallestDifference = Infinity;


      positions.forEach((position, index) => {

        const difference = Math.abs(
          currentScroll - position
        );


        if (difference < smallestDifference) {

          smallestDifference = difference;
          nearestIndex = index;

        }

      });


      dots.forEach((dot, index) => {

        const active = index === nearestIndex;


        dot.classList.toggle(
          'is-active',
          active
        );


        if (active) {

          dot.setAttribute(
            'aria-current',
            'true'
          );

        } else {

          dot.removeAttribute(
            'aria-current'
          );

        }

      });

    };


    /* ======================================================
       INITIALISATION
       ====================================================== */

    buildDots();
    updateDots();


    /* ======================================================
       MISE À JOUR AU SCROLL
       ====================================================== */

    slider.addEventListener(
      'scroll',
      updateDots,
      {
        passive: true
      }
    );


    /* ======================================================
       RECALCUL AU REDIMENSIONNEMENT
       Important pour desktop ↔ mobile
       ====================================================== */

    let resizeTimer;


    window.addEventListener('resize', () => {

      clearTimeout(resizeTimer);


      resizeTimer = setTimeout(() => {

        buildDots();
        updateDots();

      }, 150);

    });

  };


  /* ========================================================
     INITIALISATION DE TOUS LES SLIDERS
     ======================================================== */

  const initAllSliderDots = () => {

    document
      .querySelectorAll('slider-component')
      .forEach(initSliderDots);

  };


  initAllSliderDots();


  /* ========================================================
     SHOPIFY : SECTIONS CHARGÉES DYNAMIQUEMENT
     ======================================================== */

  const pageObserver = new MutationObserver(() => {

    initAllSliderDots();

  });


  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

});